export const TREATMENT_CATEGORY_IDS = {
  skin: 1,
  hair: 2,
} as const;

export const TREATMENT_CATEGORIES: { [key: number]: string } = {
  1: 'skin',
  2: 'hair',
} as const;
